var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6687,
    cy: 20.7988,
    r: 19.9305,
    stroke: "#F36F2E",
    strokeWidth: 1.47633
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0127 31.1588V20.986H25.4446L25.9547 17.003H22.0127V14.466C22.0127 13.3166 22.3329 12.5297 23.9824 12.5297H26.0726V8.97864C25.0556 8.86965 24.0334 8.81703 23.0106 8.82101C19.9771 8.82101 17.8944 10.6729 17.8944 14.0725V16.9955H14.4848V20.9785H17.9018V31.1588H22.0127Z",
    fill: "#F36F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d8d314f6bc50d34b60cd40ca5eb220ad.svg";
export { ForwardRef as ReactComponent };